<template>
  <div class="w-full h-screen bg-darkBlue">
    <el-row class="tac">
      <el-col :span="24">
        <el-menu
          default-active="home"
          class="el-menu-vertical-demo"
          background-color="#13499B"
          text-color="#fff"
          active-text-color="#ffd04b"
          @select="handleNavSelect"
        >
          <el-menu-item index="home">
            <span slot="title">首页</span>
          </el-menu-item>
          <template v-for="item in menuList">
            <menu-item :key="item?.id || item?.text" :item="item" :on-navigate="handleNavSelect" />
          </template>
          <template>
            <el-submenu index="booking" v-if="$store.state.isLogin">
              <span slot="title">开放预约</span>
              <el-menu-item
                @click="() => gotoApply()">
                <span slot="title">实验室预约</span>
              </el-menu-item>
              <el-menu-item
                @click="() => gotoMyApply()">
                <span slot="title">我的预约</span>
              </el-menu-item>
            </el-submenu>

          </template>
        </el-menu>
      </el-col>
    </el-row>
    <div
      v-if="!$store.state.isLogin"
      class="w-full px-5 pt-3 pb-10 bg-darkBlue"
      @click="handleNavigateToLogin"
    >
      <el-button class="w-full font-bold text-base text-darkBlue tracking-wider"
        >登&nbsp;&nbsp;录</el-button
      >
    </div>
    <div
      v-else
      class="w-full px-5 pt-3 pb-10 bg-darkBlue"
    >
      <el-button class="w-full font-bold text-base text-darkBlue tracking-wider"
        ><a style="display:block"
                :href="
                  '/mainsys/cmsapi/logout.do?siteName=' + siteInfo.siteName
                "
                >退出登录</a>
      </el-button>
    </div>
  </div>
</template>

<script>
import { getSiteFirstMenu } from "../api/header";
import { getMobileHeaderList } from "../utils/formatResData";
import mixins from "../hooks";
import MenuItem from "@/components/MenuItem.vue";
export default {
  components: { MenuItem },
  mixins: [mixins],
  data() {
    return {
      menuList: [],
    };
  },
  methods: {
    // 获取菜单列表
    async handleGetMenuList() {
      const res = await getSiteFirstMenu();
      const list = getMobileHeaderList(res);
      this.menuList = list;
      if (list && list.length > 0) {
        this.$store.commit('setNavList', list)
      }
    },
    // 跳转登录页
    handleNavigateToLogin() {
      this.$emit("setIsMenuVisible");
      this.$router.push({
        path: "/mobileLogin",
        name: "mobileLogin",
      });
    },

    // Deep search for top-level parent name given menuId
    deepFindTopParentText(items, menuId) {
      for (const item of items) {
        if (String(item.id) === String(menuId)) return item.text
        if (item.children && item.children.length > 0) {
          if (this.findItemInChildren(item.children, menuId)) return item.text
        }
      }
      return ''
    },
    findItemInChildren(children, menuId) {
      for (const child of children) {
        if (String(child.id) === String(menuId)) return true
        if (child.children && child.children.length > 0) {
          if (this.findItemInChildren(child.children, menuId)) return true
        }
      }
      return false
    },

    // 菜单选择处理
    handleNavSelect(index) {
      if (!index || index === 'booking') return // booking submenu has its own click handlers
      this.$emit("setIsMenuVisible");
      if (index === "home") {
        this.$router.push({ path: "/" })
        return
      }
      const topParentName = this.deepFindTopParentText(this.menuList, index)
      if (topParentName == "教学资源") {
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: index },
        })
      } else {
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: index },
        })
      }
    },
    gotoApply(){
      this.$emit("setIsMenuVisible");
      this.$router.push({
        path: "/collegeList",
      });
    },
    gotoMyApply(){
      this.$emit("setIsMenuVisible");
      this.$router.push({
        path: "/myApply",
      });
    },
  },

  created() {
    this.handleGetMenuList();
  },
};
</script>
